export default "__VITE_ASSET__C22Fs50O__"